import { html } from "lit";
import UIkit from "uikit";
import { BasicApp } from "../../layout/basicApp";
import { translate, get } from "lit-translate";

const CONTACT_WORKER_URL = "https://justyna-contact-form.justynadev.workers.dev";

class ContactTab extends BasicApp {
  constructor(props) {
    super(props);
  }
  createRenderRoot() {
    return this;
  }

  sendMessage(e) {
    e.preventDefault()
    const senderNameField = document.getElementById("mail-sender-name")
    const senderEmailField= document.getElementById("mail-sender-mail")
    const messageField = document.getElementById("mail-body")
    const honeypotField = document.getElementById("mail-website")
    senderNameField.parentElement.classList.remove("invalid")
    senderEmailField.parentElement.classList.remove("invalid")
    messageField.parentElement.classList.remove("invalid")

    const isValidName = senderNameField.checkValidity()
    const isValidEmail = senderEmailField.checkValidity()
    const isValidMessage = messageField.checkValidity()

    if (!isValidName || !isValidEmail || !isValidMessage) {
      if (!isValidName) {
        senderNameField.parentElement.classList.add("invalid")
      }
      if (!isValidEmail) {
        senderEmailField.parentElement.classList.add("invalid")
      }
      if (!isValidMessage) {
        messageField.parentElement.classList.add("invalid")
      }
      return;
    }

    const form = senderNameField.closest("form")

    const submitButton = e.currentTarget
    const spinner = submitButton.querySelector(".btn-spinner")
    const label = submitButton.querySelector(".btn-label")
    const originalLabel = label.textContent
    submitButton.disabled = true
    spinner.hidden = false
    label.textContent = get("contact.form.sending")

    fetch(CONTACT_WORKER_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: senderNameField.value,
        email: senderEmailField.value,
        message: messageField.value,
        website: honeypotField ? honeypotField.value : "",
      }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          form.reset()
          this.showResultModal(true, get("contact.form.success"))
        } else {
          this.showResultModal(false, get("contact.form.error"))
        }
      })
      .catch(() => this.showResultModal(false, get("contact.form.error")))
      .finally(() => {
        submitButton.disabled = false
        spinner.hidden = true
        label.textContent = originalLabel
      })
  }

  showResultModal(success, message) {
    const modal = document.getElementById("contact-result-modal")
    modal.classList.toggle("is-success", success)
    modal.classList.toggle("is-error", !success)
    modal.querySelector(".result-modal__text").textContent = message
    UIkit.modal(modal).show()
  }

  resetValidation(e) {
    e.target.parentElement.classList.remove("invalid")
  }

  render() {
    return html`
        <div class="contact-tab--wr">
            <h1 class="page-ttl">${translate("contact.title")}</h1>
            <p class="contact-details">${translate("contact.details")}</p>
            <form class="form">
                <fieldset class="uk-fieldset">
                    <div class="form__fields">
                        <input type="text" id="mail-website" name="website" autocomplete="off" tabindex="-1" style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;" aria-hidden="true">
                        <div class="form-checkboxes">
                            <input class="checkbox-wr" type="radio" name="tools" id="job-offer">
                            <label for="job-offer">${translate("contact.form.type.jobOffer")}</label>
                            <input class="checkbox-wr" type="radio" name="tools" id="other">
                            <label for="other">${translate("contact.form.type.other")}</label>
                        </div>
                        <div class="uk-margin uk-flex form-row">
                            <div class="uk-flex input-wr">
                                <div class="input-label">${translate("contact.form.name")}</div>
                                <label for="mail-sender-name" class="input">
                                    <input type="text" id="mail-sender-name" pattern=".{3,}" required @focusin="${this.resetValidation}">
                                    <svg width="280px" height="18px" viewBox="0 0 280 18" class="border">
                                        <path d="M0,12 L223.166144,12 C217.241379,12 217.899687,12 225.141066,12 C236.003135,12 241.9279,12 249.827586,12 C257.727273,12 264.639498,12 274.514107,12 C281.097179,12 281.755486,12 276.489028,12"></path>
                                    </svg>
                                    <svg width="14px" height="12px" viewBox="0 0 14 12" class="check">
                                        <path d="M1 7 5.5 11 L13 1"></path>
                                    </svg>
                                    <span>${translate("contact.form.invalidField")}</span>
                                </label>
                            </div>
                        </div>
                        <div class="uk-margin uk-flex">
                            <div class="uk-flex input-wr">
                                <div class="input-label">${translate("contact.form.email")}</div>
                                <label for="mail-sender-mail" class="input">
                                    <input type="email" id="mail-sender-mail" pattern=".{3,}"  required>
                                    <svg width="280px" height="18px" viewBox="0 0 280 18" class="border">
                                        <path d="M0,12 L223.166144,12 C217.241379,12 217.899687,12 225.141066,12 C236.003135,12 241.9279,12 249.827586,12 C257.727273,12 264.639498,12 274.514107,12 C281.097179,12 281.755486,12 276.489028,12"></path>
                                    </svg>
                                    <svg width="14px" height="12px" viewBox="0 0 14 12" class="check">
                                        <path d="M1 7 5.5 11 L13 1"></path>
                                    </svg>
                                    <span>${translate("contact.form.invalidField")}</span>
                                </label>
                            </div>
                        </div>
                        <div class="uk-margin textbox-lines__wr">
                            <textarea 
                                    id="mail-body" 
                                    class="uk-textarea textbox-lines" 
                                    rows="5" 
                                    placeholder="${translate('contact.form.message')}"
                                    minlength="3" 
                                    required></textarea>
                            <span>${translate("contact.form.minLength3Chars")}</span>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <button class="uk-button uk-button-primary" type="submit" @click="${this.sendMessage}">
                            <span class="btn-spinner" hidden></span>
                            <span class="btn-label">${translate("contact.form.submitButton")}</span>
                        </button>
                    </div>
                </fieldset>
            </form>
            <div id="contact-result-modal" class="result-modal" uk-modal>
                <div class="uk-modal-dialog uk-modal-body">
                    <button class="uk-modal-close-default" type="button" uk-close></button>
                    <div class="result-modal__icon">
                        <svg class="result-modal__icon-success" width="48" height="48" viewBox="0 0 52 52">
                            <circle cx="26" cy="26" r="24" fill="none"/>
                            <path d="M14 27 L22 35 L38 17"/>
                        </svg>
                        <svg class="result-modal__icon-error" width="48" height="48" viewBox="0 0 52 52">
                            <circle cx="26" cy="26" r="24" fill="none"/>
                            <path d="M17 17 L35 35 M35 17 L17 35"/>
                        </svg>
                    </div>
                    <p class="result-modal__text"></p>
                </div>
            </div>
        </div>
    `;
  }
}

customElements.define('contact-tab', ContactTab);
